import { Layout, Section } from 'layout';
import { UnmatchedDemandListScreen } from 'pages/unmatched-demand/screens/unmatched-demand-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const UnmatchedDemandPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={UnmatchedDemandListScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default UnmatchedDemandPage;
